import { ServicePriority } from "./service-priority";
import { WorkOrder } from "./work-order";

export enum TrackType {
  Padrao = "PADRAO",
  Elevador = "ELEVADOR",
  Dinamometro = "DINAMOMETRO",
}

export enum TrackStatus {
  Free = "LIVRE",
  Busy = "OCUPADA",
  WaitingParts = "AGUARDANDO_PECA",
  Finished = "FINALIZADA",
}

interface TrackMechanic {
  id: string;
  name: string;
}

export interface Track {
  id: string;
  name: string;
  type: TrackType;
  status: TrackStatus;
  priority: ServicePriority;
  startedAt?: string | null;
  endedAt?: string | null;
  mechanic?: TrackMechanic | null;
  workOrder?: WorkOrder | null;
}

